module.exports = __webpack_public_path__ + "static/media/pohon1.005c51fe.png";